export const Marquee = ({ items, className = "" }) => {
  const content = [...items, ...items];
  return (
    <div className={`relative w-full overflow-hidden border-y border-white/10 bg-[#0a0a0a] py-6 ${className}`} data-testid="marquee">
      <div className="animate-marquee">
        {content.map((it, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 font-display text-3xl md:text-5xl uppercase tracking-wide text-white/90">
            {it}
            <span className="text-gold text-xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
